export default "asset/iconfont/30f270b70fe08ffc285023a22b316e15.eot";